import { render, staticRenderFns } from "./WebVideo.vue?vue&type=template&id=a1d38262&scoped=true&"
import script from "./WebVideo.vue?vue&type=script&lang=js&"
export * from "./WebVideo.vue?vue&type=script&lang=js&"
import style0 from "./WebVideo.vue?vue&type=style&index=0&id=a1d38262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d38262",
  null
  
)

export default component.exports